import styled from 'styled-components';

/** Tarja no fluxo do documento: empurra header e conteúdo para baixo (não cobre a logo). */
export const Container = styled.div`
  margin: 0;
  padding: 0;
  flex-shrink: 0;
  width: 100%;
`;

export const Section = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  color: ${({ theme }) => theme.colors?.text?.tertiary};
  background-color: ${({ theme }) => theme.colors?.danger};
  width: 100%;
  min-height: 5.5rem;
  padding: 0.65rem 1rem;
  padding-top: max(0.65rem, env(safe-area-inset-top, 0px));
  box-shadow: 0 2px 6px ${({ theme }) => theme.colors?.shadow01 ?? 'rgba(0,0,0,0.12)'};

  @media screen and (min-width: ${(props) => props.theme.size?.large}) {
    min-height: 6rem;
    padding: 1rem 1.5rem;
    padding-top: max(1rem, env(safe-area-inset-top, 0px));
  }
`;

export const Inner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.2rem;
  max-width: min(100%, 42rem);
  width: 100%;
  text-align: center;

  @media screen and (min-width: ${(props) => props.theme.size?.large}) {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 0.35rem;
    text-align: center;
  }
`;

/** Só desktop / tablet largo: frase em linha com o nome */
export const TextDesktop = styled.span`
  font-weight: 700;
  font-size: ${({ theme }) => theme.fontSize[theme.fontSizeType].fs14};

  @media screen and (max-width: ${(props) => props.theme.size?.large}) {
    display: none;
  }

  @media screen and (min-width: ${(props) => props.theme.size?.large}) {
    font-size: ${({ theme }) => theme.fontSize[theme.fontSizeType].fs16};
  }
`;

/** Só mobile: legenda curta (antes o rótulo sumia e só aparecia o nome). */
export const TextMobile = styled.span`
  display: none;
  font-weight: 700;
  font-size: ${({ theme }) => theme.fontSize[theme.fontSizeType].fs10};
  letter-spacing: 0.04em;
  text-transform: uppercase;
  opacity: 0.92;
  line-height: 1.2;

  @media screen and (max-width: ${(props) => props.theme.size?.large}) {
    display: block;
  }
`;

export const Name = styled.span`
  font-weight: 700;
  font-size: ${({ theme }) => theme.fontSize[theme.fontSizeType].fs14};
  line-height: 1.35;
  word-break: break-word;
  hyphens: auto;

  @media screen and (min-width: ${(props) => props.theme.size?.large}) {
    font-size: ${({ theme }) => theme.fontSize[theme.fontSizeType].fs16};
  }
`;
